import React from 'react';

interface TextareaProps {
  name: string;
  value: string;
  placeholder: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  label?: string;
}

const Textarea: React.FC<TextareaProps> = ({
  name,
  value,
  placeholder,
  onChange,
  label,
}) => {
  return (
    <div className="">
      <label
        htmlFor={name}
        className="block mb-2 text-grey text-[16px] manrope capitalize"
      >
        {label}
      </label>
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="p-4 mb-3 bg-white text-[16px] h-[150px] resize-none w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
      />
    </div>
  );
};

export default Textarea;
